import { useFetchData } from '../../../hooks';
import { MaterialStatus } from '../../../types';
import { useSearchParams } from 'react-router-dom';
import { dateFormat, exportToExcel } from '../../../lib/utils';
import MaterialStatusTable from './MaterialStatusTable';
import dayjs from 'dayjs';
import MaterialStatusHeaderFilter from './MaterialStatusHeaderFilter';

const MaterialStatusPage = () => {
  const [searchParams] = useSearchParams();
  const api = '/reports/material-status';

  const { data, isLoading } = useFetchData<MaterialStatus[]>(api, {
    startDate:
      searchParams.get('start') ||
      dayjs().subtract(6, 'month').format(dateFormat),
    endDate:
      searchParams.get('end') || dayjs().add(2, 'month').format(dateFormat),
    proder: searchParams.get('proder') || '',
    pono: searchParams.get('pono') || '',
    sku: searchParams.get('sku') || '',
  });

  const handleExport = () => {
    if (data !== undefined) {
      const rows = data.map((row) => ({
        'P.O. Number': row.pono,
        'Order Date': row.orderDate,
        'Required Date': row.requiredDate,
        'Received Date': row.rrDate,
        'Delivery Status': row.status,
      }));

      exportToExcel({
        fileName: `material_status`,
        headers: [
          'P.O. Number',
          'Order Date',
          'Required Date',
          'Received Date',
          'Delivery Status',
        ],
        data: rows,
      });
    }
  };

  return (
    <>
      <div className={'page-wrapper'}>
        <MaterialStatusHeaderFilter
          startDate={
            searchParams.get('start') ||
            dayjs().subtract(6, 'month').format(dateFormat)
          }
          endDate={
            searchParams.get('end') ||
            dayjs().add(2, 'month').format(dateFormat)
          }
          handleExport={handleExport}
        />
        <MaterialStatusTable data={data} isLoading={isLoading} />
      </div>
    </>
  );
};

export default MaterialStatusPage;
